export interface AccidentEvidence {
	description: string;
	fileName: string;
	lookupId: string;
}

export class AccidentEvidence implements AccidentEvidence {
	description = "";
	fileName = "";
	lookupId = "";

	constructor(data?: Partial<AccidentEvidence>) {
		if (data) {
			for (const key of Object.keys(data)) {
				(this as any)[key] = (data as any)[key];
			}
		}
	}
}